import React, { useRef, useState } from 'react'; 
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import FormControl from '@mui/material/FormControl'; 
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';  
import Radio from '@mui/material/Radio';  
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import StopIcon from '@mui/icons-material/Stop';

import { useAppDispatch, useAppSelector } from '../../core/hooks';
import { selectFilters , updateFilters } from '../../core/reducers/reducer-main';
import styles from './styles.module.css';
import { slimGreen, slimRed, asBlue } from '../../assets/colors/palette';


const ScannerPopover = () => {
    const dispatch = useAppDispatch(); 
    const filters = useAppSelector(selectFilters); 
    const scanFilters = filters.filter((el: string) => el.includes("scan-"));
    // For now, only one val in filters at a time
    const initTradeSetupConditionVal = (scanFilters.length === 1) ? scanFilters[0] : "";
    const [tradeSetupConditionValue, setTradeSetupConditionValue] = useState(initTradeSetupConditionVal);
    
    const anchorRef = useRef(null); 
    const [anchorEl, setAnchorEl] = useState(null); 
    const open = Boolean(anchorEl); 
    const id = open ? "scanner-popover" : undefined; 

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleTradeSetupConditionChange = (event: any) => {
        setTradeSetupConditionValue(event.target.value);
    }

    const handleScanClicked = () => {
        // For now, only one val in filters at a time
        const filtersLessScan = filters.filter((el: string) => !(el.includes("scan-"))); 
        const nextFilterSet = [...filtersLessScan, tradeSetupConditionValue];
        dispatch(updateFilters(nextFilterSet))
        // handleClose()
    }

    const handleScanStopClicked = () => {
        const filtersLessScan = filters.filter((el: string) => !(el.includes("scan-"))); 
        setTradeSetupConditionValue("");
        dispatch(updateFilters(filtersLessScan))
    }

    const isScanBtnDisabled = (tradeSetupConditionValue === "");
    const scanBtnColor = (isScanBtnDisabled) ? "#e4e4e4" : "#848484"; 
    const scanBtnComp =  (filters.filter((el: string) => el.includes("scan-")).length > 0) ? (
        <div>
            <Button onClick={handleScanClicked} 
                style={{backgroundColor: "#848484", color: "white", marginRight: 8}} 
            >
                Update
            </Button>
            <Button onClick={handleScanStopClicked}
                style={{backgroundColor: "#848484", color: "white"}} 
            >
                Stop
            </Button>
        </div>
    ) : (
        <Button onClick={handleScanClicked}
            style={{backgroundColor: scanBtnColor, color: "white"}}
            disabled={isScanBtnDisabled}
        >
            Scan
        </Button>
    )

    const popoverBtnColor = (filters.filter((el: string) => el.includes("scan-")).length > 0) ? slimGreen : asBlue;
    const popoverBtnText = (filters.filter((el: string) => el.includes("scan-")).length > 0) ? "Scanned Results" : "Scan Mode";
    const stopButtonComp = (filters.filter((el: string) => el.includes("scan-")).length > 0) ? (
        <Button onClick={handleScanStopClicked}
            style={{backgroundColor: slimRed, color: "white", height: 54, width: 128}}
            startIcon={<StopIcon />}
        >
            Return
        </Button>
    ) : (undefined);
    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <ButtonGroup 
                variant="contained" color="primary" ref={anchorRef} aria-label="split button"
                style={{height: 54, boxShadow: "none"}}
            >
                <Button onClick={handleClick}
                    style={{backgroundColor: popoverBtnColor}}
                >
                    {popoverBtnText}
                </Button>
                <Button
                    color="primary"
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleClick}
                    style={{backgroundColor: popoverBtnColor}}
                >
                    <ArrowDropDownIcon />
                </Button>
            </ButtonGroup>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <div className={styles.popoverContent}>
                    <FormControl component="fieldset" style={{width: '100%'}}>
                        <FormLabel component="legend">Select Condition</FormLabel>
                        <RadioGroup aria-label="trade-setup-condition" name="trade-setup-condition" value={tradeSetupConditionValue} onChange={handleTradeSetupConditionChange}>
                            <FormControlLabel value="scan-bullish" control={<Radio />} label="Bullish" />
                            <FormControlLabel value="scan-bearish" control={<Radio />} label="Bearish" />
                            <FormControlLabel value="scan-neutral" control={<Radio />} label="Neutral" />
                        </RadioGroup>
                    </FormControl>
                    {scanBtnComp}
                </div>
            </Popover>
            {stopButtonComp}
        </div>
    )
}

export default ScannerPopover;